import { useContext } from "react";
import { ConnectionHubContext } from "../ConnectionHubProvider";
import type { ConnectionHubContextValue } from "../api/connectionHub.types";

export const useConnectionHub = (): ConnectionHubContextValue => {
  const context = useContext(ConnectionHubContext);
  if (!context) {
    throw new Error(
      "useConnectionHub must be used inside the app-level ConnectionHubProvider."
    );
  }
  return context;
};
